module.exports = __webpack_public_path__ + "static/assets/3286e2838658ebdb82f62d062b14e951.svg";